import { useSavePassportDraftMutation } from '../../../redux/api/questionnaire/questionnaire-api';
import useDraft from '../common/draft/useDraft';

export const usePassportDraft = () => {
  return useDraft(
    questionnaire => questionnaire.passportForm,
    useSavePassportDraftMutation
  );
};
